import { render, staticRenderFns } from "./CreateAppointment.vue?vue&type=template&id=2aa2ab46&scoped=true"
import script from "./CreateAppointment.vue?vue&type=script&lang=js"
export * from "./CreateAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2ab46",
  null
  
)

export default component.exports